<p>{{ label() }}</p>
<div class="value">
  <p class="bold">{{ value() }}</p>
</div>
